var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"traffic-main"},[_c('trafficBanner'),_c('trafficComponents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }